import React from "react";
import { Icon } from "../core/Icon.jsx";

/* Delta — signed change with arrow. Positive = green, negative = red.
   value is a number (sign drives colour) or pass explicit `direction`. */
export function Delta({ value, suffix = "%", direction, showArrow = true, size = "md", style, ...rest }) {
  const num = typeof value === "number" ? value : parseFloat(value);
  const dir = direction || (num > 0 ? "up" : num < 0 ? "down" : "flat");
  const color = dir === "up" ? "var(--green-success)" : dir === "down" ? "var(--red)" : "var(--text-muted)";
  const fs = size === "sm" ? 12 : size === "lg" ? 16 : 13;
  const display = typeof value === "number" ? `${num > 0 ? "+" : ""}${num}${suffix}` : value;
  return (
    <span
      className="tnum"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 2,
        color,
        fontFamily: "var(--font-sans)",
        fontWeight: 600,
        fontSize: fs,
        fontVariantNumeric: "tabular-nums",
        ...style,
      }}
      {...rest}
    >
      {showArrow && dir !== "flat" ? <Icon name={dir === "up" ? "arrowUpRight" : "arrowDownRight"} size={fs + 2} /> : null}
      {display}
    </span>
  );
}

export default Delta;
